module.exports = __webpack_public_path__ + "img/portraits_01_V.8adedd2a.webp";